import React from 'react'
import { useState, useEffect} from 'react'
import { styled } from '@mui/system';

import ImageDialog from './ImageDialog';

import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const StyledMainImage = styled('img')({
  height: '500px',
  objectFit: 'scale-down',
  cursor: 'pointer',
});

const StyledImageContainer = styled('img')({
  height: '200px',
  width: '200px',
  objectFit: 'scale-down',
});

const SwiperWrapper = styled('div')({
  display: 'grid',
});


const ImageGalleryWithCarusel = ({images}) => {
    const [selectedImage, setSelectedImage] = useState();
    const [imageDialogOpen, setImageDialogOpen] = useState(false);
    const [sliderItems, setSliderItems] = useState([]);

    useEffect(() => {
        if (images.length > 0) setSelectedImage(images[0]);
        else setSelectedImage(null);
        setSliderItems(
          images.map((image, index) => (
            <StyledImageContainer
              key={index}
              src={image}
              onClick={() => handleImageClick(image)}
              alt=""
            />
          ))
        );
    }, [images]);

    const handleImageClick = (image) => {
      setSelectedImage(image);
    };

    const handleMainImageClick = () => {
      setImageDialogOpen(true);
    };

    const handleClose = () => {
        setImageDialogOpen(false);
    };

    return (
      <>
      <StyledMainImage src={selectedImage} alt=""  onClick={handleMainImageClick} onDragStart={(e) => e.preventDefault()} />
      <SwiperWrapper>
        <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        style={{
          width: "100%",
          maxWidth: "100%",
        }}
        spaceBetween={50}
        slidesPerView={3}
        pagination={{ clickable: true }}
        onSwiper={(swiper) => console.log(swiper)}
        >
          {sliderItems.map((sliderItem, index) => (
            <SwiperSlide key={index}>{sliderItem}</SwiperSlide>
          ))}
        </Swiper>
      </SwiperWrapper>
      <ImageDialog open={imageDialogOpen} imageUrl={selectedImage} handleClose={handleClose}/>
      </>
    );
}

export default ImageGalleryWithCarusel